<template>
    <RedesignBasePopover
        :visible-arrow="false"
        :disabled="!soundsLength && !soundsHistory.length"
        popper-class="sound-badge-popover"
        trigger="click"
        width="380"
    >
        <template #reference>
            <el-badge
                :value="soundsLength"
                class="item"
            >
                <i
                    class="vc-icon-notification text-primary-actions icon-xl cursor-pointer"
                />
            </el-badge>
        </template>
        <div class="flex justify-between">
            <div class="mb-2 font-medium text-lg">
                {{ $t('general.notification.notifications') }}
            </div>
            <redesign-base-button
                v-show="currentTab === historyTab"
                size="small"
                type="soft"
                @click="clearSoundsHistory"
            >
                {{ $t('general.notification.clearHistory') }}
            </redesign-base-button>
        </div>
        <div class="divide-y divide-ui-lines">
            <redesign-radio-group
                v-model="currentTab"
                size="small"
            >
                <redesign-radio-button :label="allSoundsTab">
                    {{ $t('general.notification.currentNotificationsTabLabel') }}
                </redesign-radio-button>
                <redesign-radio-button :label="historyTab">
                    {{ $t('general.notification.historyTabLabel') }}
                </redesign-radio-button>
            </redesign-radio-group>
            <div v-show="currentTab === allSoundsTab">
                <div
                    v-for="(sound) in sounds"
                    :key="sound.id + allSoundsTab"
                    class="p-2 sound-notification-item"
                >
                    <redesign-sound-badge-notification
                        :sound="sound"
                    />
                </div>
            </div>
            <div v-show="currentTab === historyTab">
                <div
                    v-for="(sound) in soundsHistory"
                    :key="sound.id + sound.timestamp + historyTab"
                    class="p-2 sound-notification-item"
                >
                    <redesign-sound-badge-notification
                        :sound="sound"
                    />
                </div>
            </div>
        </div>
    </RedesignBasePopover>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { Badge as ElBadge } from 'element-ui'
import RedesignBasePopover from '@/components/RedesignBaseComponents/RedesignBasePopover.vue'
import { getQueueSounds, getQueueSoundHistory, clearSoundsHistory, soundsLength } from '@/composables/useSoundsStoreData'
import RedesignRadioButton from '@/components/RedesignBaseComponents/Inputs/RedesignRadioButton.vue'
import RedesignRadioGroup from '@/components/RedesignBaseComponents/Inputs/RedesignRadioGroup.vue'
import RedesignBaseButton from '@/components/RedesignBaseComponents/Buttons/RedesignBaseButton.vue'
import RedesignSoundBadgeNotification from '@/components/RedesignComponents/Navbar/RedesignSoundBadgeNotification.vue'

const allSoundsTab = 'All'
const historyTab = 'History'

const currentTab = ref(allSoundsTab)

const sounds = computed(() => {
    return getQueueSounds()
})

const soundsHistory = computed(() => {
    return getQueueSoundHistory()
})

function getClass (sound: { isPlaying: boolean, played: boolean }) {
    let cssClass = ''
    if (sound.isPlaying) {
        cssClass += 'isPlaying'
    }
    if (sound.played) {
        cssClass += 'played'
    }
    return cssClass
}
</script>

<style lang="scss">
.redesign-popover.sound-badge-popover {
    @apply max-h-64 overflow-y-auto;
    .sound-notification-item {
        @apply text-default-text;
    }

    .isPlaying {
        @apply text-active-elements rounded;
    }

    .played {
        @apply opacity-70;
    }
}

.redesign-popover[x-placement^=bottom].sound-badge-popover {
    @apply mt-2;
}
</style>
